module.exports = window["dfShared"]["tables"];